var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevicesIcons = function SvgDevicesIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    clipPath: "url(#devicesIcons_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.845 5.5a.75.75 0 0 1 .75-.75H9.2a.75.75 0 1 1 0 1.5H7.594a.75.75 0 0 1-.75-.75m4.615 1.93h3.7c.446 0 .874.064 1.277.183.204.06.42-.086.42-.299v-1.34a3.907 3.907 0 0 0-3.901-3.904H3.84A3.907 3.907 0 0 0-.062 5.973v10.205A3.906 3.906 0 0 0 3.84 20.08h2.98a.316.316 0 0 0 .304-.377 4 4 0 0 1-.064-.674V11.83c0-2.386 2.014-4.4 4.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.263 19.285a.757.757 0 1 1 0-1.515.757.757 0 0 1 0 1.515m1.9-10.357h-3.7c-1.571 0-2.9 1.328-2.9 2.9v7.2c0 1.572 1.329 2.9 2.9 2.9h3.7c1.572 0 2.9-1.328 2.9-2.9v-7.2a2.87 2.87 0 0 0-2.9-2.9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "devicesIcons_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v24H0z"
  })))));
};
export default SvgDevicesIcons;